import React from "react";

const PopupMenuComp = (props) => {
  return (
    <div className="popup-menu">
      <span className="closebtn" onClick={props.handleClose}>
        &times;
      </span>
      <div className="popup-menu-content">
        <ul className="popup-menu-items">
          <li onClick={() => props.handleMenuClick("/pretrade")}>
            <img src="/img/icon/trade.svg" alt="icon header" />
            <div className="popup-menu-icon-label">Pre-Trade Request</div>
          </li>
          <li onClick={() => props.handleMenuClick("/oba")}>
            <img src="/img/icon/one-one.svg" alt="icon header" />
            <div>OBA</div>
          </li>
          <li onClick={() => props.handleMenuClick("/gift")}>
            <img src="/img/icon/gift.svg" alt="icon header" />
            <div>Gift & Entertainment</div>
          </li>
          <li onClick={() => props.handleMenuClick("/political")}>
            <img src="/img/icon/donation.svg" alt="icon header" />
            <div>Political Contribution</div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PopupMenuComp;
